import CryptoJS from 'crypto-js';
// 加密
const ivStr = 'F1x3d!vS3cr3tK3y';
const key = CryptoJS.enc.Utf8.parse('pL#3dR8&vN2^jK9!'); // 16/24/32 位密钥
const iv = CryptoJS.enc.Utf8.parse(ivStr); // 16 位 IV

export function decrypted(str) {
  const bytes = CryptoJS.enc.Base64.parse(str);
  // 取前16字节作为IV
  const iv = CryptoJS.lib.WordArray.create(bytes.words.slice(0, 4)); // 16字节 = 4个word
  // 取后面的作为CipherText
  const cipherText = CryptoJS.lib.WordArray.create(bytes.words.slice(4), bytes.sigBytes - 16);

  const decrypted = CryptoJS.AES.decrypt({ ciphertext: cipherText }, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}
export function encrypted() {
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse('Hello AES!'), key, {
    iv: iv,
    mode: CryptoJS.mode.CBC, // 常见模式：CBC / ECB
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

}
